import React, { useMemo } from "react";
import Widget from "../../features/widget/Widget";
import { counterWidgetLayoutConfig, counterWidgetLayoutType } from "../../../enums/counterWidgetLayoutType";
import CounterItem from "./counterItem/CounterItem";
import classes from "./CounterWidget.module.css";

const CounterWidget = ({ counters = [], color, titleColor = "#FFF", title, icon, mainLink, width, height, links, className = "", topContent, layoutType = counterWidgetLayoutType.standard }) => {

    const getCounterRowsLayout = (countersList = [], type = counterWidgetLayoutType.standard) => {
        const count = countersList.length;
        if (count <= 0) return [];

        const { singleRowUpTo, multiRowUpTo, splitRowCount, maxRowCount } = counterWidgetLayoutConfig[type];
        const rowCount = count <= singleRowUpTo ? 1 : count <= multiRowUpTo ? splitRowCount : maxRowCount;
        const maxCols = Math.ceil(count / rowCount);
        const baseCellsPerRow = Math.floor(count / rowCount);
        const rowsWithExtraCell = count % rowCount;

        let index = 0;

        return Array.from({ length: rowCount }, (_, rowIndex) => {
            const cellCount = baseCellsPerRow + (rowIndex < rowsWithExtraCell ? 1 : 0);
            const items = countersList.slice(index, index + cellCount);
            index += cellCount;

            return {
                items,
                maxCols,
                centerPartialRow: cellCount < maxCols,
            };
        });
    };

    const rowsWithCounters = useMemo(() => getCounterRowsLayout(counters, layoutType), [counters, layoutType]);

    return (
        <Widget
            className={className}
            width={width}
            height={height}
            color={color}
            titleColor={titleColor}
            title={title}
            icon={icon}
            mainLink={mainLink}
            links={links}
            contentScrollable={false}
        >
            <div className={classes.Content}>
                <div className={classes.TopContent}>
                    {topContent}
                </div>
                <div className={classes.CountersArea} data-count={counters.length} data-rows={rowsWithCounters.length}>
                    {rowsWithCounters.map((row, rowIndex) => (
                        <div key={rowIndex} className={`${classes.Row} ${row.centerPartialRow ? classes.RowCentered : ""}`}>
                            {row.items.map((counter, cellIndex) => (
                                <div key={cellIndex} className={classes.Cell} style={{ flexBasis: `${100 / row.maxCols}%` }}>
                                    <CounterItem
                                        count={counter.count}
                                        icon={counter.picture}
                                        label={counter.name}
                                    />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </Widget>
    );
};

export default CounterWidget;
